import { render, staticRenderFns } from "./CombinMyFooter.vue?vue&type=template&id=0e614dd0&scoped=true&"
import script from "./CombinMyFooter.vue?vue&type=script&lang=js&"
export * from "./CombinMyFooter.vue?vue&type=script&lang=js&"
import style0 from "./CombinMyFooter.vue?vue&type=style&index=0&id=0e614dd0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e614dd0",
  null
  
)

export default component.exports